import $ from 'jquery'

$('.js-training-center-form').on('click', function () {
  $(this).trigger('submit')
})